<template>
<div class="blog-header">
    <div class="blog-header-content">
        <p v-t="'BLOG.TITLE1'" class="top-title" />
        <h1 v-t="'BLOG.TITLE2'" />
    </div>
</div>
<div class="subhead"><h1>Blog Posts Through the Years</h1></div>
<div class="years">
    <div v-for="y in years" :key="y" class="year">
        <NuxtLink :to="localeRoute(`/blog/year/${y}`)">{{ y }}</NuxtLink>
    </div>
</div>
</template>

<script setup lang="ts">

import type { CMS } from '$plugins/cms'
import { JBGWeb } from '$types/JBGWeb'

const i18n = useI18n()
const app = useNuxtApp()
const localeRoute = useLocaleRoute()

const { data: years } = await useAsyncData<string[]>(
    'years',
    async () => {
        try {
            const options: (CMS.FetchOptions & { withMeta?: false | undefined; }) = {
                fields: ['slug', 'title', 'publishedAt'],
                sort: 'publishedAt:asc',
                pagination: {
                    page: 1,
                    pageSize: 1
                },
                locale: i18n.locale.value
            }
            const currentYear = (new Date()).getFullYear()
            let oldestYear = currentYear
            const oldest = await app.$cms.fetchMany<JBGWeb.BlogPost[]>('blog-posts', options)
            if (oldest) {
                oldestYear = new Date(oldest[0].publishedAt).getFullYear()
            }
            const yrs = []
            for (let i = currentYear; i >= oldestYear; i--) {
                yrs.push(i.toString())
            }
            return yrs
        } catch (error) {
            console.error('error loading blog posts')
            throw error
        }
    }
)
</script>

<style lang="scss">
@use "$styles/kit.scss" as *;

$overlayGradient: linear-gradient(0deg,
    rgba(0,0,0,0) 30%,
    rgba(0,0,0,.75) 100%);

.blog-header {
    background-image: url("/images/blog-header.jpg");
    background-size: cover;
    background-position: center;
    height: 400px;
    margin-top: -88px;
    margin-bottom: 30px;
    padding-top: 100px;
    display: flex;
    @include mq-small-and-less {
        height: 300px;
    }

    &::after { // overlay
        content: '';
        z-index: 1;
        position: absolute;
        top: 0;
        left: 50%;
        width: 100%;
        height: 400px;
        background: $overlayGradient;
        transform: translateX(-50%);
        @include mq-small-and-less {
            height: 300px;
        }

    }

    .blog-header-content {
        display: inline-block;
        z-index: 2;
        text-align: center;
        width: 100%;
        margin-top: auto;
        margin-bottom: auto;
        padding-bottom: 50px;
        text-shadow: 0px 0px 10px #000000a0;
        h1, .top-title {
            text-transform: uppercase;
            margin: 0;
        }
        h1 {
            font-size: 72px;
            margin: 0;
        }
        .top-title {
            font-size: 40px;
            font-weight: bold;
        }
        @include mq-small-and-less {
            h1 { font-size: 40px; }
            .top-title { font-size: 25px; }
        }
    }
}

.subhead {
    text-align: center;
    margin-bottom: 50px;
}

.years {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    max-width: 600px;
    margin: auto;
    gap: 30px;
    .year {
        text-align: center;
        align-content: center;
        font-size: 32px;

    }
}


</style>
